import type { ButtonHTMLAttributes, FunctionComponent } from 'react'

import { useState } from 'react'

export const MitIdLoginMockUpPage: FunctionComponent<{
	onContinueClick: () => void
}> = ({ onContinueClick }) => {
	return (
		<div
			style={{
				maxWidth: '400px',
				margin: '50px auto',
				padding: '20px',
				border: '1px solid #ddd',
				borderRadius: '8px',
				fontFamily: 'Arial, sans-serif',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<h2 style={{ fontSize: '16px', fontWeight: 'bold' }}>Log på</h2>
				<svg
					width="61"
					height="16"
					viewBox="0 0 61 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_1_5)">
						<path
							d="M19.2 0C20.2 0 21 0.8 21 1.8C21 2.8 20.2 3.6 19.2 3.6C18.2 3.6 17.4 2.8 17.4 1.8C17.4 0.8 18.2 0 19.2 0ZM40.4 0C42.5 0 44.2 1.7 44.2 3.8C44.2 5.9 42.5 7.6 40.4 7.6C38.3 7.6 36.6 5.9 36.6 3.8C36.6 1.7 38.3 0 40.4 0ZM20.7 4.9V15.8H17.7V4.9H20.7ZM2.9 0.8L7.5 7.9L12 0.8H14.9V15.8H11.8V6.1L7.5 12.5H7.4L3.1 6.1V15.8H0V0.8H2.9ZM40.4 9C44 9 46.9 11 47.3 15.8H33.6C34 11 36.9 9 40.4 9ZM51.9 0.2C58.3 0.2 61 3.7 61 8C61 12.3 58.3 15.8 51.9 15.8H49.3V0.2H51.9ZM27.1 1.9V4.9H29.5V7.3H27.1V12.1C27.1 13 27.6 13.3 28.4 13.3C28.9 13.3 29.4 13.2 29.7 12.9V15.6C29.3 15.8 28.5 15.9 27.7 15.9C25.5 15.9 24.1 14.8 24.1 12.4V7.3H22.4V4.9H24.1V1.9H27.1V1.9Z"
							fill="#0060E6"
						/>
					</g>
					<defs>
						<clipPath id="clip0_1_5">
							<rect width="61" height="16" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</div>
			<hr style={{ border: 'none', borderTop: '2px solid #00000010' }} />
			<LoginForm onContinueClick={onContinueClick} />
			<div
				style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}
			>
				<input
					id="rememberMe"
					type="checkbox"
					style={{ marginRight: '10px' }}
				/>
				<label htmlFor="rememberMe" style={{ fontSize: '14px' }}>
					Husk mig
				</label>
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					fontSize: '14px',
				}}
			>
				<button
					style={{
						padding: '10px',
						fontSize: '14px',
						color: '#007bff',
						background: 'none',
						border: 'none',
						cursor: 'pointer',
						textDecoration: 'underline',
					}}
				>
					Afbryd
				</button>
				<button
					style={{
						padding: '10px',
						fontSize: '14px',
						color: '#007bff',
						background: 'none',
						border: 'none',
						cursor: 'pointer',
						textDecoration: 'underline',
					}}
				>
					Hjælp
				</button>
			</div>
		</div>
	)
}

interface InputProps {
	label: string
	id: string
	placeholder?: string
	value?: string
	onChange: (value: string) => void
}

type ButtonProps = {
	label: string
	onClick: () => void
	disabled?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

const TextInput: React.FC<InputProps> = ({
	label,
	id,
	placeholder,
	value,
	onChange,
}) => {
	return (
		<div style={{ marginBottom: '20px' }}>
			<label
				style={{
					fontSize: '14px',
					fontWeight: 'bold',
					marginBottom: '8px',
					display: 'block',
				}}
			>
				{label}
				<span style={{ fontSize: '12px', color: '#888', cursor: 'pointer' }}>
					ⓘ
				</span>
			</label>
			<input
				id={id}
				type="text"
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				style={{
					width: '100%',
					padding: '10px',
					fontSize: '14px',
					borderRadius: '4px',
					border: '1px solid #ccc',
				}}
			/>
		</div>
	)
}

const Button: React.FC<ButtonProps> = ({
	label,
	onClick,
	disabled = false,
	...props
}) => {
	const baseStyle: React.CSSProperties = {
		width: '100%',
		padding: '10px',
		fontSize: '14px',
		fontWeight: 600,
		borderRadius: '4px',
		border: 'none',
		cursor: disabled ? 'not-allowed' : 'pointer',
	}

	const styles = {
		disabled: { ...baseStyle, backgroundColor: '#ccc', color: '#fff' },
		default: { ...baseStyle, backgroundColor: '#0060E6', color: '#fff' },
	}

	return (
		<button
			{...props}
			onClick={onClick}
			disabled={disabled}
			style={disabled ? styles.disabled : styles.default}
			onMouseOver={(e) =>
				!disabled && (e.currentTarget.style.backgroundColor = '#004CB8')
			}
			onFocus={(e) =>
				!disabled && (e.currentTarget.style.backgroundColor = '#004CB8')
			}
			onMouseOut={(e) =>
				!disabled && (e.currentTarget.style.backgroundColor = '#007bff')
			}
			onBlur={(e) =>
				!disabled && (e.currentTarget.style.backgroundColor = '#007bff')
			}
		>
			{label} <span style={{ marginLeft: '8px' }}>→</span>
		</button>
	)
}

const LoginForm: React.FC<{ onContinueClick: () => void }> = ({
	onContinueClick,
}) => {
	const [userId, setUserId] = useState<string>()

	return (
		<div
			style={{
				maxWidth: '400px',
				margin: '50px auto',
				fontFamily: 'Arial, sans-serif',
			}}
		>
			<TextInput
				label="BRUGER-ID"
				id="input-user-id"
				placeholder="Indtast bruger-id"
				value={userId}
				onChange={setUserId}
			/>
			<Button
				id="btn-continue"
				label="FORTSÆT"
				onClick={onContinueClick}
				disabled={!userId}
			/>
			<div style={{ margin: '20px 0', textAlign: 'right' }}>
				<button
					type="button"
					style={{
						fontSize: '14px',
						color: '#007bff',
						textDecoration: 'none',
						background: 'none',
						border: 'none',
						padding: 0,
						cursor: 'pointer',
					}}
					aria-label="Glemt bruger-ID?"
				>
					Glemt bruger-ID?
				</button>
			</div>
		</div>
	)
}
